import { useCallback } from 'react'
import req from '@sportninja/common/api/request'
import { PlayerData, PlayerHighlight } from '../types'

export function usePlayerData() {
  const fetchPlayer = useCallback(
    async (playerId: string): Promise<PlayerData> => {
      const response = await req(`/players/${playerId}`)
      return response.data
    },
    []
  )

  const fetchHighlights = useCallback(
    async (playerId: string): Promise<PlayerHighlight[]> => {
      try {
        const response = await req(`/players/${playerId}/highlights`)
        return response?.data?.length > 0 ? response.data : []
      } catch {
        return []
      }
    },
    []
  )

  return { fetchPlayer, fetchHighlights }
}
